export default __webpack_public_path__ + "static/media/default.26b8422c.svg";